import Link from 'next/link';
import { useState } from 'react';

// 서브메뉴 아이템 타입 정의
interface SubMenuItem {
  pathname: string;
  label: React.ReactNode;
  isOpenNewWindow?: boolean;
}

// 메뉴 아이템 타입 정의
interface MenuItemProps {
  pathname: string;
  label: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  isOpenNewWindow?: boolean;
  subMenuList?: SubMenuItem[];
}

// 메뉴 아이템 컴포넌트
const MenuItem = ({ pathname, label, onClick, isOpenNewWindow, subMenuList }: MenuItemProps) => {
  const [isOpenSubMenu, setIsOpenSubMenu] = useState(false);
  const hasSubMenu = !!subMenuList;

  // 새 창에서 열기 속성 설정 헬퍼 함수
  const getOpenNewWindowProps = (
    _isOpenNewWindow: boolean | undefined,
  ): { target: '_blank'; rel: 'noreferrer' } | undefined => {
    return _isOpenNewWindow ? { target: '_blank', rel: 'noreferrer' } : undefined;
  };

  // 서브메뉴 토글 함수
  const toggleSubMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsOpenSubMenu((prev) => !prev);
  };

  return (
    <li className="relative border-b border-[#D6D6D6]">
      {!hasSubMenu ? (
        <Link
          href={pathname}
          onClick={onClick}
          {...getOpenNewWindowProps(isOpenNewWindow)}
          className="block relative py-[17px] px-[30px] text-lg font-extrabold leading-normal cursor-pointer"
        >
          {label}
        </Link>
      ) : (
        <>
          <a
            className={`block relative py-[17px] px-[30px] text-lg font-extrabold leading-normal cursor-pointer
              ${
                hasSubMenu
                  ? 'after:content-[""] after:block after:absolute after:right-9 after:top-1/2 after:w-3 after:h-[6px] after:mt-[-3px] after:bg-[url(/images/icon/arw_down_black3.svg)] after:bg-no-repeat after:bg-center after:bg-cover after:transition-all after:duration-300'
                  : ''
              }
              ${isOpenSubMenu ? 'after:rotate-180' : ''}`}
            onClick={toggleSubMenu}
          >
            {label}
          </a>
          {hasSubMenu && isOpenSubMenu && (
            <div className="border-t border-[#D6D6D6]">
              <ul className="py-5 px-[30px] flex flex-col gap-5">
                {subMenuList.map((subMenu) => (
                  <li key={subMenu.pathname}>
                    <Link
                      href={subMenu.pathname}
                      onClick={onClick}
                      {...getOpenNewWindowProps(subMenu.isOpenNewWindow)}
                      className="text-[#121212] text-base font-medium leading-normal"
                    >
                      {subMenu.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}
    </li>
  );
};

export default MenuItem;
